// @ts-nocheck
import {Column} from 'react-table'
import {IssueOrgansName} from './IssueOrgansName'
import {IssueOrgansDescription} from './IssueOrgansDescription'
// import {IssueOrgansLastLoginCell} from './IssueOrgansLastLoginCell'
// import {IssueOrgansTwoStepsCell} from './IssueOrgansTwoStepsCell'
import {IssueOrgansActionsCell} from './IssueOrgansActionsCell'
//import {IssueOrgansSelectionCell} from './IssueOrgansSelectionCell'
import {IssueOrgansCustomHeader} from './IssueOrgansCustomHeader'
//import {IssueOrgansSelectionHeader} from './IssueOrgansSelectionHeader'
import {IssueOrgans} from '../../core/_models'

const IssueOrgansColumns: ReadonlyArray<Column<IssueOrgans>> = [
  {
    Header: (props) => (
      <IssueOrgansCustomHeader
        tableProps={props}
        title='COMMON.INPUT_NAME'
        className='fs-8 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'name',
    Cell: ({...props}) => <IssueOrgansName issue_organs={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <IssueOrgansCustomHeader
        tableProps={props}
        title='COMMON.DESCRIPTION'
        className='fs-8 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'description',
    Cell: ({...props}) => <IssueOrgansDescription issue_organs={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <IssueOrgansCustomHeader
        tableProps={props}
        title='MENU.ACTIONS'
        className='text-center fs-8 min-w-100px'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => <IssueOrgansActionsCell data={props.data[props.row.index]} />,
  },
]

export {IssueOrgansColumns}
